import React from "react";
import CommonUtil from "../../../../utils/CommonUtil";
import { Comment } from "antd";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

const constructComments = comments => {
  var containers = [];

  for (var i = 0; i < comments.length; i++) {
    const comment = comments[i];
    const author = comment.user;
    const sendingTime = CommonUtil.formatDateTime(comment.createdDate);
    const action = [<span>{comment.messageLogType}</span>];
    const container = (
      <>
        <div className="comment-font-content">
          <Comment
            content={comment.note}
            author={author}
            datetime={sendingTime}
            actions={action}
          />
        </div>
      </>
    );

    containers.push(container);
  }
  return containers;
};

const CommentList = props => {
  const containers = constructComments(props.comments);
  return (
    <PerfectScrollbar>
      <div className="comment-container">{containers}</div>
    </PerfectScrollbar>
  );
};

export default CommentList;
